import React, { useEffect, useState } from 'react';

import { useAuth } from '../../hooks/AuthContext';

import api from '../../services/api';
import Logout from '../../pages/Logout';

import { useListChildren } from '../../hooks/ParentContext';

import Modal from '../Modal';
import Loader from '../Loader';

import { Container } from './styles';

const FirstLogin = () => {
  const { selectedOne } = useListChildren();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [toggleModal, setToggleModal] = useState(false);

  useEffect(() => {
    api.get(`child/${selectedOne._id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      if (res.data.data.fitbitId) {
        setToggleModal(false);
      } else {
        setToggleModal(true)
      };
    }).catch((err) => {
      console.log(err);
    })
  }, [selectedOne])

  const token = localStorage.getItem("@Ocariot:token");
  const goToFitbit = async () => {
    setLoading(true);
    api.get(`token/${selectedOne._id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": 'no-cache, no-store',
        Pragma: 'no-cache',
      },
    }).then((res) => {
      window.location.href = res.data.url;
      setLoading(false);
    }).catch((err) => {
      console.log(err);
      setLoading(false);
    });

  }
  return (
    <Container>
      <Modal title={`Bem vindo(a) ao OCARIoT`} show={toggleModal} onClose={() => setToggleModal(false)}>
        <div className="initial-body">
          <h3>Olá {user.name},</h3>
          <br />
          <p>
            Estamos muito felizes em te ter por aqui!
            Sua missão começa agora!
            Ajude seu filho(a) a possuir hábitos mais saudáveis durante o dia-a-dia e acompanhe de perto o seu desempenho.
          </p>
          <br />
          <p>
            Para obter estátiscas personalizadas de hábitos de sono ou atividades física é preciso
            primeiro se conectar com a smartband FitBit. Clique no botão abaixo e faça seu cadastro!
            E não se esqueça de autorizar o acesso das informações para a nossa plataforma, viu!?
            Contamos com você!
          </p>
          <br />
          <br />
          <div className="footer-button">

            <button id="fitbit-button" onClick={goToFitbit}>
              {loading ? <Loader color="white" /> : "Conectar smartband"}
            </button>
          </div>
        </div>

      </Modal>
    </Container>
  );
}

export default FirstLogin;